import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { SidePage, Section } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import {
  SpendAdjustmentsFormEdit,
  SpendAdjustmentsFormCopy,
} from 'scenes/SpendAdjustments/components/SpendAdjustmentForm';
import SpendAdjustmentsTitle from 'scenes/SpendAdjustments/components/SpendAdjustmentTitle';
import { useLoadSADetails, useIsUpdating } from 'scenes/SpendAdjustments/data';

import Actions from '../Actions';
import ActionsLog from './ActionsLog';
import General from './General';
import MetaData from './MetaData';
import Statistic from './Statistic';

export const TAB_DETAILS = 'details';

const SpendAdjustmentDetails = ({
  id,
  activeTabId = TAB_DETAILS,
  onClose,
  onExited,
  open,
}) => {
  const isUpdating = useIsUpdating();
  const [childComponent, openChildComponent] = useChildComponent();
  const { data, isLoading, isRefetching } = useLoadSADetails(id);

  const handleDelete = async () => {
    onClose();
  };

  const handleEdit = async () => {
    openChildComponent(SpendAdjustmentsFormEdit, {
      id,
    });
  };

  const handleCopy = async () => {
    openChildComponent(SpendAdjustmentsFormCopy, {
      id,
    });
  };

  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={isLoading || isUpdating}
      fetching={isRefetching}
      open={open}
      size={'lg'}
    >
      <SidePage.Title
        title={`Spend Adjustment #${id}`}
        subTitle={!isEmpty(data) ? <SpendAdjustmentsTitle {...data} /> : null}
      />
      <SidePage.Tabs activeTabId={activeTabId}>
        <SidePage.Tab label={TAB_DETAILS}>
          <SidePage.NewBody wrapper={true} dense={true}>
            <SidePage.NewContent>
              {!isEmpty(data) ? (
                <React.Fragment>
                  <Section title={'General'}>
                    <General data={data} />
                  </Section>
                  <Section title={'Statistic'}>
                    <Statistic data={data} />
                  </Section>
                </React.Fragment>
              ) : null}
            </SidePage.NewContent>
            <SidePage.Sidebar
              actions={
                <Actions
                  actions={data?.actions}
                  data={data}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                  onCopy={handleCopy}
                  withViewLog={false}
                />
              }
            >
              <MetaData data={data} />
            </SidePage.Sidebar>
          </SidePage.NewBody>
        </SidePage.Tab>
        <SidePage.Tab label={'Actions Log'}>
          <SidePage.NewBody>
            <ActionsLog id={id} />
          </SidePage.NewBody>
        </SidePage.Tab>
      </SidePage.Tabs>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
      {childComponent}
    </SidePage>
  );
};

export default SpendAdjustmentDetails;
